import { useRef, useState } from "react";

const MiniInfoWindow = (props) => {
    
    const {
        source,
        close_function,
        button_title,
        button_function,
        title,
        data,
    } = props;

    const [ isMinimized, setIsMinimized ] = useState(false);
    const [ isClosed, setIsClosed ] = useState(false);
    //const _info_section_container_ref = useRef(null);

    const toggleMinimizeWindow = () => {
        setIsMinimized(!isMinimized);
    }

    let closeWindowFunction = close_function;
    if(!closeWindowFunction){
        closeWindowFunction = () => {
            setIsClosed(true);
        }
    }

    let _btn_tile = (button_title || "action");
    let _source = (source || "Unidentified Source");
    let _title = (title || "Untitled Popup");
    let data_props = Object.keys(data.item);

    return <>
        {
            !isClosed ?
            <div style={{border: "1px solid green", background: "black", position: "fixed", left: 10, bottom: 10, borderRadius: 8, width: 300, zIndex: 10000}}>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", background: "rgba(255,255,255,0.1)", padding: 20, borderBottom: "1px solid rgba(255,255,255,0.1)"}}>
                    <p style={{color: "lightgreen", fontSize: 13}}>
                        <i style={{marginRight: 10, color: "rgba(255,255,255,0.5)"}}
                            className="fa-solid fa-lightbulb"></i>
                        {_title}</p>
                    <div style={{display: "flex"}}>
                        <p onClick={toggleMinimizeWindow}
                            className="tooltip_parent" style={{cursor: "pointer", color: "rgba(255,255,255,0.8)"}}>
                            {
                                isMinimized ?
                                <i className="fa-solid fa-angle-up"></i> :
                                <i className="fa-solid fa-angle-down"></i>
                            }
                            <span style={{color: "black", textAlign: "center", width: 100, borderRadius: 8}} className="tooltip">
                                {
                                    isMinimized ?
                                    "Show Details" :
                                    "Minize window"
                                }
                            </span>
                        </p>
                        <p onClick={closeWindowFunction}
                            className="tooltip_parent" style={{cursor: "pointer", color: "rgba(255,0,0,0.8)", marginLeft: 15}}>
                            <i className="fa-solid fa-times"></i>
                            <span style={{color: "black", textAlign: "center", width: 100, borderRadius: 8}} className="tooltip">
                                Close window
                            </span>
                        </p>
                    </div>
                </div>
                {
                    !isMinimized &&
                    <div style={{padding: 20}}>
                        {
                            data_props?.map(key=>{
                                if(key==="item_details" || 
                                    key==="user_id" || 
                                    key==="itinerary_id" ||
                                    key==="userToken"
                                )
                                    return;
                                return <p style={{fontSize: 13, color: "white"}}>
                                    {
                                        key==="link" ?
                                        <>
                                            <span className="tooltip_parent"
                                                style={{fontSize: 13, color: "blue", cursor: "pointer", marginRight: 10, fontSize: 13, textDecoration: "underline"}}>
                                                <i style={{marginRight: 10, color: "rgba(255,255,255,0.5)"}}
                                                    className="fa-solid fa-link"></i>
                                                View Link
                                                <span style={{fontSize: 11, color: "black",borderRadius: 8, padding: 10, zIndex: 2}} className="tooltip">
                                                    {data.item[key]}
                                                </span>
                                                <br/><br/>
                                            </span>  
                                        </> :
                                        <>
                                            <span style={{color: "orange", marginRight: 10, fontSize: 13}}>
                                                {(key?.replaceAll("_", " "))}:</span>
                                            {data.item[key]}
                                        </>
                                    }
                            </p>
                            })
                            
                        }
                        {
                            button_function &&
                            <div onClick={button_function} 
                                style={{marginTop: 20, textAlign: "center"}}>
                                <span style={{fontSize: 13, textDecoration: "underline", color: "red", cursor: "pointer"}}>
                                    <i style={{marginRight: 10, color: "rgba(255,255,255,0.5)"}}
                                        className="fa-solid fa-refresh"></i>
                                    {_btn_tile}</span>
                            </div>
                        }
                        <p style={{textAlign: "center", marginTop: 20, fontSize: 12, color: "rgba(255,255,255,0.8)", padding: 10, backgroundColor: "rgba(255,255,255,0.1)", borderTop: "1px solid rgba(255,255,255,0.1)"}}>
                            Event Source - <span style={{fontSize: 12, color: "blue"}}>
                                {_source}
                            </span>
                        </p>
                    </div>
                }
            </div> : <div onClick={()=>setIsClosed(false)} className="tooltip_parent" 
                style={{position: "fixed", cursor: "pointer",  left: 10, bottom: 10, zIndex: 10000, borderRadius: "8", width: 40, height: 40, display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgb(34, 34, 34)"}}>
                <i style={{color: "white"}}
                    className="fa-solid fa-window-restore"></i>
                <span style={{color: "black", textAlign: "center", width: 100, borderRadius: 8, top: -30, left: -5}} className="tooltip">
                    Show Window
                </span>
            </div>
        }
    </>
}

export default MiniInfoWindow;